import { useAppDispatch, useAppSelector } from 'app/hooks';
import { useSaveStructureStepCompletedMutation } from 'features/api/project-api';
import { addManuallyCompletedStep } from 'features/ui';
import { useCallback } from 'react';

export function useMarkStructureStepCompleted() {
  const dispatch = useAppDispatch();
  const { structureUniqueId } = useAppSelector((state) => state.structure);
  const [saveStepCompleted] = useSaveStructureStepCompletedMutation();

  return useCallback(
    (stepCode: string, subStepCode: string) => {
      dispatch(addManuallyCompletedStep(subStepCode));
      if (!structureUniqueId) return;
      saveStepCompleted({
        structureUniqueId,
        stepCode,
        subStepCode,
        completed: true
      })
        .unwrap()
        .catch((err) => console.error('Failed to save step completed:', err));
    },
    [dispatch, structureUniqueId, saveStepCompleted]
  );
}
